import { useEffect, useMemo, useState } from "react";
import { getCallStreamUrl } from "../service/CallCenterCalls";
import { createSSEClient } from "../utils/sseClient";

export const useCallStream = (callId) => {
  const [stateEvent, setStateEvent] = useState(null);
  const [connectionState, setConnectionState] = useState("idle");

  const streamUrl = useMemo(() => {
    if (!callId) return null;
    return getCallStreamUrl(callId);
  }, [callId]);

  useEffect(() => {
    if (!streamUrl) return undefined;

    setStateEvent(null);
    setConnectionState("connecting");
    const client = createSSEClient({
      url: streamUrl,
      onOpen: () => setConnectionState("connected"),
      onMessage: (payload) => {
        setConnectionState("connected");
        setStateEvent({
          callId: payload?.callId,
          status: payload?.status,
          duration: payload?.duration,
          recordingUrl: payload?.recordingUrl,
          ticketId: payload?.ticketId,
          providerCallId: payload?.providerCallId,
          updatedAt: payload?.updatedAt,
        });
      },
      onError: () => setConnectionState("reconnecting"),
    });

    return () => {
      setConnectionState("closed");
      client.close();
    };
  }, [streamUrl]);

  return {
    stateEvent,
    connectionState,
  };
};
